// src/components/Icon/icons.js
// Import all icon assets as React components using SVGR syntax
// --- HEADING ICONS ---
import { ReactComponent as UserTie } from 'assets/icons-decorative/user-tie.svg';
import { ReactComponent as Skillshare } from 'assets/icons-decorative/skillshare.svg';
import { ReactComponent as LaptopBriefcase } from 'assets/icons-decorative/laptop-briefcase-32-regular.svg';
import { ReactComponent as Rocket } from 'assets/icons-decorative/rocket.svg';
import { ReactComponent as Seedling } from 'assets/icons-decorative/seedling.svg';
import { ReactComponent as BlueBook } from 'assets/icons-decorative/blue-book.svg';
import { ReactComponent as WindowDevTools } from 'assets/icons-decorative/window-dev-tools-24-regular.svg';
import { ReactComponent as DevCycle } from 'assets/icons-decorative/cycle.svg';
import { ReactComponent as TouchTripleOutline } from 'assets/icons-decorative/touch-triple-outline.svg';
import { ReactComponent as GlobeShare } from 'assets/icons-decorative/globe-share.svg';
import { ReactComponent as EarthNetwork } from 'assets/icons-decorative/earth-network.svg';
import { ReactComponent as TargetArrow } from 'assets/icons-decorative/target-arrow-16-regular.svg';
import { ReactComponent as VirtualNetworkToolbox } from 'assets/icons-decorative/virtual-network-toolbox-20-filled.svg';
import { ReactComponent as CompassOffLoop } from 'assets/icons-decorative/compass-off-loop.svg';
import { ReactComponent as ErrorTriangle } from 'assets/icons-decorative/error-triangle.svg';
import { ReactComponent as SadFace } from 'assets/icons-decorative/smiley-sad-fill.svg';


// --- SKILLS ICONS ---
// --- Languages & Frameworks ---
import { ReactComponent as NextjsIcon } from 'assets/icons/nextjs.svg';
import { ReactComponent as ReactIcon } from 'assets/icons/react.svg';
import { ReactComponent as TypescriptIcon } from 'assets/icons/typescript.svg';
import { ReactComponent as JavascriptIcon } from 'assets/icons/javascript.svg';
import { ReactComponent as Html5Icon } from 'assets/icons/html5.svg';
import { ReactComponent as Css3Icon } from 'assets/icons/css3.svg';

// --- Core Development Practices ---
import { ReactComponent as GitIcon } from 'assets/icons/git.svg';
import { ReactComponent as GithubIcon } from 'assets/icons/github.svg';
import { ReactComponent as ApiIcon } from 'assets/icons/api.svg';
import { ReactComponent as ResponsiveDesignIcon } from 'assets/icons/responsive-design.svg';
import { ReactComponent as SeoIcon } from 'assets/icons/seo.svg';
import { ReactComponent as AccessibilityIcon } from 'assets/icons/accessibility.svg';
import { ReactComponent as CrossBrowserIcon } from 'assets/icons/cross-browser.svg';

// --- State Management ---
import { ReactComponent as ReduxIcon } from 'assets/icons/redux.svg';
import { ReactComponent as ReactRouterIcon } from 'assets/icons/react-router.svg';

// --- Styling (Specialized) ---
import { ReactComponent as SassIcon } from 'assets/icons/sass.svg';
import { ReactComponent as CssModulesIcon } from 'assets/icons/css-modules.svg';
import { ReactComponent as TailwindIcon } from 'assets/icons/tailwind.svg';
import { ReactComponent as BootstrapIcon } from 'assets/icons/bootstrap.svg';

// --- Build Tools & Others ---
import { ReactComponent as FigmaIcon } from 'assets/icons/figma.svg';
import { ReactComponent as ViteIcon } from 'assets/icons/vite.svg';
import { ReactComponent as WebpackIcon } from 'assets/icons/webpack.svg';
import { ReactComponent as BabelIcon } from 'assets/icons/babel.svg';
import { ReactComponent as PnpmIcon } from 'assets/icons/pnpm.svg';
import { ReactComponent as NpmIcon } from 'assets/icons/npm.svg';
import { ReactComponent as EmmetIcon } from 'assets/icons/emmet.svg';
import { ReactComponent as NodejsIcon } from 'assets/icons/nodejs.svg';
import { ReactComponent as VscodeIcon } from 'assets/icons/vscode.svg';

// --- CMS & E-commerce ---
import { ReactComponent as WordpressIcon } from 'assets/icons/wordpress.svg';
import { ReactComponent as WoocommerceIcon } from 'assets/icons/woocommerce.svg';


// --- CONTACT ICONS ---
import { ReactComponent as LinkedInIcon } from 'assets/icons/linkedin.svg';
//import { ReactComponent as GithubIcon } from 'assets/icons/github.svg';
import { ReactComponent as XIcon } from 'assets/icons/x-twitter.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email.svg';
import { ReactComponent as SmsIcon } from 'assets/icons/sms.svg';
import { ReactComponent as WhatsappIcon } from 'assets/icons/whatsapp.svg';

// --- BRAND ICONS ---
import { ReactComponent as BrandLogo } from 'assets/icons/brand-logo.svg';

// --- ThEME ICONS ---
import { ReactComponent as LightThemeIcon } from 'assets/icons/sun.svg';
import { ReactComponent as DarkThemeIcon } from 'assets/icons/moon-rising-filled-loop.svg';

// --- MENU ICONS ---
import { ReactComponent as HamburgerIcon } from 'assets/icons/hamburger-menu-linear.svg';
import { ReactComponent as MenuCloseIcon } from 'assets/icons/round-close.svg';

// --- ERROR ICONS ---
import { ReactComponent as ErrorOutlineIcon } from 'assets/icons/baseline-error-outline.svg';

// Export an object mapping *string keys* to the imported components
export const icons = {
  // --- Decorative Icons ---
  UserTie,
  Skillshare,
  LaptopBriefcase,
  Rocket,
  Seedling,
  BlueBook,
  WindowDevTools,
  DevCycle,
  TouchTripleOutline,
  GlobeShare,
  EarthNetwork,
  TargetArrow,
  VirtualNetworkToolbox,
  CompassOffLoop,
  ErrorTriangle,
  SadFace,

  // --- Languages & Frameworks ---
  NextjsIcon,
  ReactIcon,
  TypescriptIcon,
  JavascriptIcon,
  Html5Icon,
  Css3Icon,

  // --- Core Development Practices ---
  GitIcon,
  GithubIcon,
  ApiIcon,
  ResponsiveDesignIcon,
  SeoIcon,
  AccessibilityIcon,
  CrossBrowserIcon,

  // --- State Management ---
  ReduxIcon,
  ReactRouterIcon,

  // --- Styling (Specialized) ---
  SassIcon,
  CssModulesIcon,
  TailwindIcon,
  BootstrapIcon,

  // --- Build Tools & Others ---
  FigmaIcon,
  ViteIcon,
  WebpackIcon,
  BabelIcon,
  PnpmIcon,
  NpmIcon,
  EmmetIcon,
  NodejsIcon,
  VscodeIcon,

  // --- CMS & E-commerce ---
  WordpressIcon,
  WoocommerceIcon,

  // --- Contact Icons ---
  LinkedInIcon,
  //GithubIcon,
  XIcon,
  EmailIcon,
  SmsIcon,
  WhatsappIcon,

  // --- Brand Icon ---
  BrandLogo,

  // --- Theme Icons ---
  LightThemeIcon,
  DarkThemeIcon,

  // --- Menu Icons ---
  HamburgerIcon,
  MenuCloseIcon,

  // --- Error Icons ---
  ErrorOutlineIcon,
};
